import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_NATUREZA_OPERACAO_CADASTRO_RAPIDO,
    CANCEL_NATUREZA_OPERACAO_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelNaturezaOperacaoCadastroRapido() {
  yield put({ type: CANCEL_NATUREZA_OPERACAO_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelNaturezaOperacaoCadastroRapido() {
  yield takeLatest(CANCEL_NATUREZA_OPERACAO_CADASTRO_RAPIDO, sagaCancelNaturezaOperacaoCadastroRapido)
}